module.exports = __webpack_public_path__ + "dba04605b7ade73dc090fc2aeb49c241.svg";